import React from "react";

import { Ds } from "@accurx/design";
import { i } from "images";

import { StyledContent, StyledPageWrapper } from "../MapWorkspacePage.styles";

export const MapWorkspaceNoMappingIsNeeded = () => {
    return (
        <StyledPageWrapper
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <StyledContent gap="3" flexDirection="column" alignItems="center">
                <img
                    src={i("illustrations/clinical_building.svg")}
                    alt=""
                    width="80"
                    height="80"
                />

                <Ds.Text>
                    You don't have to map your workspace to an organisation,{" "}
                    <br />
                    so there are no further actions to take here.
                </Ds.Text>
                <Ds.Text weight="bold">You can close this window.</Ds.Text>
            </StyledContent>
        </StyledPageWrapper>
    );
};
